import React from 'react';

interface RootErrorBoundaryFallbackProps {
  isCausedByTranslation: boolean;
}

const RootErrorBoundaryFallback = ({
  isCausedByTranslation,
}: RootErrorBoundaryFallbackProps) => {
  const tryAgainLink = (
    <a
      href="/"
      onClick={(e) => {
        e.preventDefault();
        window.location.reload();
      }}
    >
      try again
    </a>
  );

  const contactUsLink = <a href="mailto:support@slab.com">contact us</a>;

  return (
    <div style={{ margin: 12 }}>
      <h2>Oops! Something went wrong.</h2>
      {isCausedByTranslation ? (
        <>
          <p>
            The error is most likely caused by a translation tool. Please
            disable it and {tryAgainLink}.
          </p>
          <p>If the problem persists, feel free to {contactUsLink}.</p>
        </>
      ) : (
        <>
          <p>The error has been logged and we’ll be on it!</p>
          <p>
            Please {tryAgainLink} later or {contactUsLink} if the problem
            persists.
          </p>
        </>
      )}
    </div>
  );
};

export default RootErrorBoundaryFallback;
